module.exports = __webpack_public_path__ + "static/media/1--mobile.2abded6d.webp";